<template>
	<transition name="modal">
		<div class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Criar Atendimentos de Subgrupo</h3>
				</div>
				<div class="modal-body">
					<!--
					<div class="row">
						<div class="col-md-12">
							<div :class="{'form-group': true, 'has-error':errors.has('bloqueados') }">
								<label for="">Desbloquear todos os bloqueados</label>
								<v-select v-validate="'required'" v-model="desbloquear" :options="[{label: 'Sim', value: 'true'}, {label: 'Não', value: 'false'}]" name="bloqueados" ref="bloqueados"></v-select>
								<span v-show="errors.has('bloqueados')" class="help-block">Escolha uma opção</span>
							</div>
						</div>
					</div>
					-->
					<template v-if="dados.tipo_consumo == 1">
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label for="">Atendimentos distribuídos (Por paciente)</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_paciente_original | zero"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group disable">
									<label for="">Atendimentos disponíveis (Por paciente)</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_paciente_alterada | zero"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="">Atendimentos bloqueados (Por paciente)</label>
									<input
										type="number"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_paciente_bloqueada | zero"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="">Atendimentos criados (Por paciente)</label>
									<input
										type="number"
										min="0"
										class="form-control"
										:disabled="dados.quantidade_paciente_bloqueada > 0"
										v-model.number="dados.quantidade_paciente_criada"
									>
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label for="">Atendimentos distribuidos</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_atendimento_original | zero"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group disable">
									<label for="">Atendimentos disponíveis</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_atendimento_alterada | zero"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="">Atendimentos bloqueados</label>
									<input
										type="number"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_atendimento_bloqueada | zero"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="">Atendimentos criados</label>
									<input
										type="number"
										min="0"
										class="form-control"
										:disabled="dados.quantidade_atendimento_bloqueada > 0"
										v-model.number="dados.quantidade_atendimento_criada"
									>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label for="">Locais distribuidos</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_local_original | zero"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group disable">
									<label for="">Locais disponíveis</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_local_alterada | zero"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="">Locais bloqueados</label>
									<input
										type="number"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_local_bloqueada | zero"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="">Locais criados</label>
									<input
										type="number"
										min="0"
										class="form-control"
										:disabled="dados.quantidade_local_bloqueada > 0"
										v-model.number="dados.quantidade_local_criada"
									>
								</div>
							</div>
						</div>
					</template>
				</div>
				<div class="modal-footer">
					<div class="row">
						<div class="col-md-12">
							<button
								@click="salvar()"
								class="btn btn-primary pull-right"
								type="button"
								:disabled="dados.quantidade_local_bloqueada > 0 && dados.quantidade_atendimento_bloqueada > 0"
							><i class="fa fa-save"></i> Salvar</button>
							<button tag="a" @click="$emit('close')" class="btn btn-default pull-left"><i class="fa fa-close"></i> Cancelar</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from "axios"; // Cliente para requisição http

export default {
	filters: { },
	computed: { },
	props: ["show", "id"],
	data: () => ({
		filtros: { },
		desbloquear: {
			label: 'Não',
			value: 'false'
		},
        bloqueados: {
            atendimento: 0,
            local: 0,
			paciente: 0
        },
		dados: {
            quantidade_atendimento: 0,
			quantidade_atendimento_original: 0,
			quantidade_atendimento_alterada: 0,
			quantidade_atendimento_bloqueada: "",
			quantidade_atendimento_criada: "",
            quantidade_local: 0,
            quantidade_local_original: 0,
            quantidade_local_alterada: 0,
			quantidade_local_bloqueada: "",
			quantidade_local_criada: "",
			quantidade_paciente_original: 0,
            quantidade_paciente_alterada: 0,
			quantidade_paciente_bloqueada: "",
			quantidade_paciente_criada: "",
			tipo_consumo: 0
        },
	}),
	mounted() {
		document.body.addEventListener('keyup', e => {
			if (e.keyCode === 27) {
				this.$emit('close');
			}
		})
	},
	methods: {
		getData(id) {
			this.$store.commit("TOGGLE_LOADING");
			let config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;
			axios.get(
				`${this.$store.state.serverURI}/api/distribuicao/agenda/getDistribuicaoContratoSubgrupoAtendimentosById/${id}`,
				config
			).then(response => {
                this.dados = response.data;
                this.bloqueados.atendimento = this.dados.quantidade_atendimento_bloqueada || 0;
                this.dados.quantidade_atendimento_alterada = this.dados.quantidade_atendimento;
                this.bloqueados.local = this.dados.quantidade_local_bloqueada || 0;
                this.dados.quantidade_local_alterada = this.dados.quantidade_local;
				this.bloqueados.paciente = this.dados.quantidade_paciente_bloqueada || 0;
                this.dados.quantidade_paciente_alterada = this.dados.quantidade_paciente;
				this.$store.commit("TOGGLE_LOADING");
			}).catch(error => {
				this.$store.commit("throwException", error);
            });

		},
        salvar() {
            this.$store.commit("TOGGLE_LOADING");
			let config = this.$store.getters.getHeaderAuth;
			this.dados.desbloquear = this.desbloquear.value;
			axios.post(
				`${this.$store.state.serverURI}/api/distribuicao/agenda/criarAtendimentoSubgrupo/${this.dados.id}`,
				this.dados,
				config
			).then(response => {
                this.$emit('atualizar');
                this.$emit('close');
				this.$store.commit("TOGGLE_LOADING");
			}).catch(error => {
				this.$store.commit("throwException", error);
            });
        }
	},
	watch: {
		'show': function (value, oldValue) {
			if (value) {
				this.getData(this.id);
			}
			this.desbloquear = {
				label: 'Não',
				value: 'false'
			}
			this.quantidade_atendimento_criada = ''
			this.quantidade_local_criada = ''
			this.quantidade_paciente_criada = ''
		},
		'desbloquear': function (value, oldValue) {
			if (value) {
				if (value.value == 'true') {
					this.dados.quantidade_atendimento_alterada = this.dados.quantidade_atendimento + this.bloqueados.atendimento + (parseInt(this.dados.quantidade_atendimento_criada) || 0);
					this.dados.quantidade_atendimento_bloqueada = 0;
					this.dados.quantidade_local_alterada = this.dados.quantidade_local + this.bloqueados.local + (parseInt(this.dados.quantidade_local_criada) || 0);
					this.dados.quantidade_local_bloqueada = 0;
				} else {
					this.dados.quantidade_atendimento_alterada = this.dados.quantidade_atendimento + (parseInt(this.dados.quantidade_atendimento_criada) || 0);
					this.dados.quantidade_atendimento_bloqueada = this.bloqueados.atendimento;
					this.dados.quantidade_atendimento_criada = this.bloqueados.atendimento == 0 ? this.dados.quantidade_atendimento_criada : '';
					this.dados.quantidade_local_alterada = this.dados.quantidade_local + (parseInt(this.dados.quantidade_local_criada) || 0);
					this.dados.quantidade_local_bloqueada = this.bloqueados.local;
					this.dados.quantidade_local_criada = this.bloqueados.local == 0 ? this.dados.quantidade_local_criada : '';
				}
			}
		},
        'dados.quantidade_atendimento_criada': function (value, oldValue) {
			let qtd = parseInt(this.dados.quantidade_atendimento) + parseInt(this.bloqueados.atendimento);
			this.dados.quantidade_atendimento_alterada = qtd + (parseInt(value) || 0);
		},
		'dados.quantidade_paciente_criada': function (value, oldValue) {
			let qtd = parseInt(this.dados.quantidade_paciente) + parseInt(this.bloqueados.paciente);
			this.dados.quantidade_paciente_alterada = qtd + (parseInt(value) || 0);
		},
        'dados.quantidade_local_criada': function (value, oldValue) {
            let qtd = parseInt(this.dados.quantidade_local) + parseInt(this.bloqueados.local);
            this.dados.quantidade_local_alterada = qtd + (parseInt(value) || 0);
		},
    },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// criarSubgruposModal.vue?273ae85b